import gql from 'graphql-tag';
import { apollo } from 'src/features';
import { serverError } from 'src/utils';

const mutation = gql`
mutation HoldActivity($activityId: ID!) {
  holdActivity(activityId: $activityId) {
    id
    state
  }
}`;

const fieldsName = {
  id: 'T_ACTIVITY_ID',
  state: 'T_ONHOLD_OPERATOR_ACTIVITY',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function holdActivity(activityId) {
  return apollo.client.mutate({
    variables: {
      activityId,
    },
    mutation,
  }).then((res) => res.data.holdActivity)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default holdActivity;
